module.exports = __webpack_public_path__ + "static/retail-content-image-retail-units-pl-v2-6ce30211413f324f1c1cf2f6dd96bf72.jpg";